import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StatusHandler } from '../../../components'
import { fetchOrganization as fetcher } from '../slice'
import { organizationContext as context } from './context'

const NAME = 'organization'

const OrganizationProvider = ({id, children}) => {
  const dispatch = useDispatch()
  const _state = useSelector(state => state[NAME])
  const { status, error, data } = _state

  useEffect(() => {
    if(status === 'idle') dispatch(fetcher(id))
  }, [status, dispatch, id])

  return (
    <context.Provider value={{ [NAME]: data }}>
      <StatusHandler
        status={status}
        error={error}
        onRetry={() => dispatch(fetcher(id))}
      >
        {children}
      </StatusHandler>
    </context.Provider>
  )
}

export { OrganizationProvider }
